import { Base } from "../Base";
export class Class extends Base {
    name;
    class = "undefined";
    constructor(name = "undefined") {
        super();
        this.name = name;
    }
    is(value) {
        return value === undefined;
    }
    static create(name) {
        return new Class(name);
    }
}
//# sourceMappingURL=Class.js.map